export default __webpack_public_path__ + "static/media/star-check.c4b08899.svg";